import React, { useContext } from 'react'
import { Route, Redirect } from 'react-router-dom'
import { hasLogbookEnabled } from '@BUP/services/BraveUp'
import { OrganizationContext } from '@BUP/contexts/OrganizationContext'

const LogbookRoute = ({ component: Component, ...rest }) => {
  const organization = useContext(OrganizationContext)
  return (
    <Route
      {...rest}
      render={props =>
        hasLogbookEnabled(organization)
          ? (
            <Component
              {...props}
            />
            )
          : (
            <Redirect to='/' />
            )}
    />
  )
}

export default LogbookRoute
